import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useMemo, useState } from "react";
import { Search } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/admin/users")({
  component: AdminUsers,
});

interface Row {
  id: string;
  nickname: string;
  created_at: string;
  ridesCreated?: number;
  ridesJoined?: number;
}

function AdminUsers() {
  const [rows, setRows] = useState<Row[]>([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const { data } = await supabase.from("profiles").select("id, nickname, created_at").order("created_at", { ascending: false }).limit(500);
      const list = (data as Row[]) || [];
      if (list.length) {
        const [{ data: rides }, { data: parts }] = await Promise.all([
          supabase.from("rides").select("creator_id"),
          supabase.from("ride_participants").select("user_id"),
        ]);
        const c: Record<string, number> = {}; const j: Record<string, number> = {};
        (rides || []).forEach((r: any) => { c[r.creator_id] = (c[r.creator_id] || 0) + 1; });
        (parts || []).forEach((p: any) => { j[p.user_id] = (j[p.user_id] || 0) + 1; });
        list.forEach((r) => { r.ridesCreated = c[r.id] || 0; r.ridesJoined = j[r.id] || 0; });
      }
      setRows(list);
      setLoading(false);
    })();
  }, []);

  const filtered = useMemo(() => {
    const term = q.trim().toLowerCase();
    if (!term) return rows;
    return rows.filter((r) => r.nickname?.toLowerCase().includes(term));
  }, [rows, q]);

  return (
    <div>
      <h1 className="font-display text-3xl">Usuarios</h1>
      <p className="text-sm text-muted-foreground">{rows.length} riders registrados.</p>

      <div className="mt-4 relative max-w-sm">
        <Search className="absolute left-3 top-2.5 h-4 w-4 text-muted-foreground" />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Buscar por nickname…"
          className="w-full rounded-xl border border-border bg-surface py-2 pl-9 pr-3 text-sm outline-none focus:border-primary"
        />
      </div>

      <div className="mt-4 overflow-hidden rounded-2xl border border-border bg-surface">
        <div className="grid grid-cols-[1.6fr_0.6fr_0.6fr_0.9fr] gap-3 border-b border-border bg-[#0f0f0f] px-4 py-2.5 text-[11px] uppercase tracking-wider text-muted-foreground">
          <div>Nickname</div><div>Creadas</div><div>Unidas</div><div>Alta</div>
        </div>
        {loading ? <div className="p-6 text-sm text-muted-foreground">Cargando…</div>
        : filtered.length === 0 ? <div className="p-6 text-center text-sm text-muted-foreground">Sin resultados.</div>
        : filtered.map((r) => (
          <div key={r.id} className="grid grid-cols-[1.6fr_0.6fr_0.6fr_0.9fr] gap-3 items-center border-b border-border px-4 py-3 text-sm last:border-0">
            <div className="truncate font-medium">@{r.nickname}</div>
            <div className="text-xs">{r.ridesCreated}</div>
            <div className="text-xs">{r.ridesJoined}</div>
            <div className="text-xs text-muted-foreground">{new Date(r.created_at).toLocaleDateString("es-ES")}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
